import { useState, useEffect } from "react"
import { get } from "../../utils/apiClient"
import PracticesManagement from "./practicesTabs/practicesManagement"
import PracticesAssociation from "./practicesTabs/practicesAssociation"
import SubfolderManagement from "./practicesTabs/subfolderManagement"
import SubfolderAssociation from "./practicesTabs/subfolderAssociation"

const tabs = [
  {
    key: "practicesManagement",
    label: "Practices Management",
  },
  {
    key: "practicesAssociation",
    label: "Practices Association",
  },
  {
    key: "subfolderManagement",
    label: "Subfolder Management",
  },
  {
    key: "subfolderAssociation",
    label: "Subfolder Association",
  },
]

const shouldLoadPractices = (tabKey) =>
  tabKey === "subfolderManagement" || tabKey === "subfolderAssociation"

const Practices = ({ authUser }) => {
  let defaultTab = "practicesManagement"
  if (authUser?.userRole === "ADMIN") {
    defaultTab = "subfolderManagement"
  }

  const [tab, setTab] = useState(defaultTab)
  const [loading, setLoading] = useState(shouldLoadPractices(defaultTab))
  const [selectedPractice, setSelectedPractice] = useState([])
  const [practices, setPractices] = useState([])

  const fetchPractices = async (onMount = false) => {
    try {
      const data = await get("/practice/loggedInAdminPracticeAssociation")

      // Set practices
      setPractices(data?.practices)

      if (onMount) {
        setSelectedPractice(data?.practices[0])
      } else {
        if (selectedPractice.practiceId) {
          const onSelect = data?.practices.find(
            (app) => app.practiceId === selectedPractice.practiceId,
          )

          setSelectedPractice(onSelect)
        }
      }
    } catch (error) {
      console.error("Failed to fetch subfolders", error)
    }
  }

  let permittedTabs = tabs
  if (authUser.userRole === "SUPER_ADMIN") {
    permittedTabs = permittedTabs.filter(
      (t) =>
        t.key !== "subfolderManagement" && t.key !== "subfolderAssociation",
    )
  } else if (authUser.userRole === "ADMIN") {
    permittedTabs = permittedTabs.filter(
      (t) =>
        t.key === "subfolderManagement" || t.key === "subfolderAssociation",
    )
  }

  const loadPractices = async (onMount = false) => {
    setLoading(true)
    await fetchPractices(onMount)
    setLoading(false)
  }

  // useEffect(() => {
  //   loadPractices()
  // }, [tab])

  useEffect(() => {
    if (!shouldLoadPractices(tab)) {
      setLoading(false)
      return
    }

    if (practices.length === 0) {
      loadPractices(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, practices.length])

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
        <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
          <div className="settings-tab-container">
            {/* <div
              className="list-header-container"
              style={{
                width: "80%",
              }}
            > */}
            <div
              className="tabs-container"
              style={{
                display: "flex",
                justifyContent: "left",
              }}
            >
              {/* <button
                title="Click to reload files"
                className="refresh-button"
                onClick={() => {
                  fetchApps()
                }}
              >
                ↻
              </button> */}
              <div
                className="fax-view-tabs"
                style={{ width: "700px", border: "none" }}
              >
                {permittedTabs.map((t) => (
                  <div
                    key={t.key}
                    className={`settings-tab-right-tabs ${
                      tab === t.key ? "selected" : ""
                    }`}
                    onClick={() => setTab(t.key)}
                  >
                    {t.label}
                  </div>
                ))}
              </div>
            </div>
            {/* </div> */}
          </div>

          {loading ? (
            <div className="loading-container-fax-list">
              <div className="loading-message">Loading...</div>
            </div>
          ) : (
            <>
              {{
                practicesManagement: <PracticesManagement />,
                practicesAssociation: <PracticesAssociation />,
                subfolderManagement: (
                  <SubfolderManagement
                    practices={practices}
                    setSelectedPractice={setSelectedPractice}
                    selectedPractice={selectedPractice}
                    fetchPractices={() => fetchPractices()}
                  />
                ),
                subfolderAssociation: (
                  <SubfolderAssociation
                    practices={practices}
                    setSelectedPractice={setSelectedPractice}
                    selectedPractice={selectedPractice}
                  />
                ),
              }[tab] || null}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Practices
